interface ServerMerge {
  mergedServer: string;
  mergeDate: string;
}

interface ServerMergeHistory {
  [key: string]: ServerMerge[];
}

// CAUTION:
// AI should ask for permission before editing fullHistoricServerMap or consolidatedServerMap!!

// Full historic mapping of all server merges
export const fullHistoricServerMap: ServerMergeHistory = {
  'Antonius Bayle': [
    { mergedServer: 'Kane Bayle', mergeDate: '22-Mar-05' },
    { mergedServer: 'Kael Drakkel', mergeDate: '30-Jun-05' },
    { mergedServer: 'Sebilis', mergeDate: '30-Jun-05' },
    { mergedServer: 'Venril Sathir', mergeDate: '30-Jun-05' }
  ],
  'Bertoxxulous': [
    { mergedServer: 'Saryrn', mergeDate: '22-Jun-10' },
    { mergedServer: 'Tholuxe Paells', mergeDate: '28-Apr-05' }
  ],
  'Bristlebane': [
    { mergedServer: 'Solusek Ro', mergeDate: '23-Mar-05' },
    { mergedServer: 'The Tribunal', mergeDate: '22-Jun-10' }
  ],
  'Cazic-Thule': [
    { mergedServer: 'Fennin Ro', mergeDate: '22-Jun-10' },
    { mergedServer: 'Brell Serilis', mergeDate: '7-Apr-05' }
  ],
  'Drinal': [
    { mergedServer: 'Maelin Starpyre', mergeDate: '22-Jun-10' },
    { mergedServer: 'Tarew Marr', mergeDate: '14-Apr-05' }
  ],
  'Druzzil Ro': [
    { mergedServer: 'The Combine', mergeDate: '4-Mar-09' },
    { mergedServer: 'Xev', mergeDate: '19-May-05' }
  ],
  'Erollisi Marr': [
    { mergedServer: 'Morell Thule', mergeDate: '16-May-05' },
    { mergedServer: 'The Nameless', mergeDate: '22-Jun-10' }
  ],
  'Fennin Ro': [
    { mergedServer: 'Torvonnilous', mergeDate: '23-May-05' }
  ],
  'Fippy Darkpaw': [
    { mergedServer: 'Vulak\'Aerr', mergeDate: '18-Oct-17' }
  ],
  'Firiona Vie': [
    { mergedServer: 'Brekt', mergeDate: '20-Apr-20' }
  ],
  'Luclin': [
    { mergedServer: 'Veeshan', mergeDate: '25-Apr-05' },
    { mergedServer: 'Stromm', mergeDate: '22-Jun-10' }
  ],
  'Maelin Starpyre': [
    { mergedServer: 'Vazaelle', mergeDate: '9-May-05' }
  ],
  'Player Choice': [
    { mergedServer: 'Stormhammer', mergeDate: '1-Feb-06' }
  ],
  'Povar': [
    { mergedServer: 'Morden Rasp', mergeDate: '11-Apr-05' },
    { mergedServer: 'Quellious', mergeDate: '22-Jun-10' }
  ],
  'Prexus': [
    { mergedServer: 'Terris Thule', mergeDate: '26-May-05' }
  ],
  'Quellious': [
    { mergedServer: 'Rodcet Nife', mergeDate: '12-May-05' }
  ],
  'Ragefire': [
    { mergedServer: 'Lockjaw', mergeDate: '20-Apr-20' }
  ],
  'Saryrn': [
    { mergedServer: 'Mithaniel Marr', mergeDate: '18-Apr-05' }
  ],
  'The Combine': [
    { mergedServer: 'The Sleeper', mergeDate: '21-Mar-07' }
  ],
  'The Nameless': [
    { mergedServer: 'Innoruuk', mergeDate: '2-May-05' }
  ],
  'The Rathe': [
    { mergedServer: 'Karana', mergeDate: '18-Apr-05' },
    { mergedServer: 'Prexus', mergeDate: '22-Jun-10' }
  ],
  'The Seventh Hammer': [
    { mergedServer: 'Lanys T\'Vyl', mergeDate: '11-Apr-05' }
  ],
  'The Tribunal': [
    { mergedServer: 'Ayonae Ro', mergeDate: '21-Apr-05' }
  ],
  'Tunare': [
    { mergedServer: 'E\'ci', mergeDate: '31-May-05' },
    { mergedServer: 'Mayong', mergeDate: '9-Sep-10' },
    { mergedServer: 'The Seventh Hammer', mergeDate: '22-Jun-10' }
  ],
  'Vox': [
    { mergedServer: 'Fippy Darkpaw', mergeDate: '20-Apr-20' },
    { mergedServer: 'Phingel', mergeDate: '20-Jul-22' },
    { mergedServer: 'Miragul', mergeDate: '20-Jul-22' },
    { mergedServer: 'Trakanon', mergeDate: '20-Apr-20' }
  ],
  'Xegony': [
    { mergedServer: 'Druzzil Ro', mergeDate: '22-Jun-10' },
    { mergedServer: 'Zebuxoruk', mergeDate: '5-May-05' }
  ],
  'Zek': [
    { mergedServer: 'Rallos Zek', mergeDate: '8-Feb-05' },
    { mergedServer: 'Tallon Zek', mergeDate: '8-Feb-05' },
    { mergedServer: 'Sullon Zek', mergeDate: '8-Feb-05' },
    { mergedServer: 'Vallon Zek', mergeDate: '8-Feb-05' }
  ]
};

// Hardcoded consolidated server map showing all servers that were ultimately merged into each final server
export const consolidatedServerMap: { [key: string]: string[] } = {
  'Antonius Bayle': [
    'Kane Bayle', 'Kael Drakkel', 'Sebilis', 'Venril Sathir'
  ],
  'Bertoxxulous': [
    'Saryrn', 'Mithaniel Marr', 'Tholuxe Paells'
  ],
  'Bristlebane': [
    'Solusek Ro', 'The Tribunal', 'Ayonae Ro'
  ],
  'Cazic-Thule': [
    'Fennin Ro', 'Torvonnilous', 'Brell Serilis'
  ],
  'Drinal': [
    'Maelin Starpyre', 'Vazaelle', 'Tarew Marr'
  ],
  'Druzzil Ro': [
    'The Combine', 'The Sleeper', 'Xev'
  ],
  'Erollisi Marr': [
    'Morell Thule', 'The Nameless', 'Innoruuk'
  ],
  'Firiona Vie': [
    'Brekt'
  ],
  'Luclin': [
    'Veeshan', 'Stromm'
  ],
  'Player Choice': [
    'Stormhammer'
  ],
  'Povar': [
    'Morden Rasp', 'Quellious', 'Rodcet Nife'
  ],
  'The Rathe': [
    'Karana', 'Prexus', 'Terris Thule'
  ],
  'Tunare': [
    'E\'ci', 'Mayong', 'The Seventh Hammer', 'Lanys T\'Vyl'
  ],
  'Vox': [
    'Fippy Darkpaw', 'Vulak\'Aerr', 'Phingel', 'Miragul', 'Trakanon'
  ],
  'Xegony': [
    'Druzzil Ro', 'The Combine', 'The Sleeper', 'Xev', 'Zebuxoruk'
  ],
  'Zek': [
    'Rallos Zek', 'Tallon Zek', 'Sullon Zek', 'Vallon Zek'
  ]
};

// Processed server merge pairs showing [originalServer, destinationServer]
export const serverMergePairs: [string, string][] = [
  ["Ayonae Ro", "The Tribunal"],
  ["Brell Serilis", "Cazic-Thule"],
  ["Brekt", "Firiona Vie"],
  ["Druzzil Ro", "Xegony"],
  ["E'ci", "Tunare"],
  ["Fennin Ro", "Cazic-Thule"],
  ["Fippy Darkpaw", "Vox"],
  ["Innoruuk", "The Nameless"],
  ["Kael Drakkel", "Antonius Bayle"],
  ["Kane Bayle", "Antonius Bayle"],
  ["Karana", "The Rathe"],
  ["Lanys T'Vyl", "The Seventh Hammer"],
  ["Lockjaw", "Ragefire"],
  ["Maelin Starpyre", "Drinal"],
  ["Mayong", "Tunare"],
  ["Miragul", "Vox"],
  ["Mithaniel Marr", "Saryrn"],
  ["Morden Rasp", "Povar"],
  ["Morell Thule", "Erollisi Marr"],
  ["Phingel", "Vox"],
  ["Prexus", "The Rathe"],
  ["Quellious", "Povar"],
  ["Rallos Zek", "Zek"],
  ["Rodcet Nife", "Quellious"],
  ["Saryrn", "Bertoxxulous"],
  ["Sebilis", "Antonius Bayle"],
  ["Solusek Ro", "Bristlebane"],
  ["Stormhammer", "Player Choice"],
  ["Stromm", "Luclin"],
  ["Sullon Zek", "Zek"],
  ["Tallon Zek", "Zek"],
  ["Tarew Marr", "Drinal"],
  ["Terris Thule", "Prexus"],
  ["The Combine", "Druzzil Ro"],
  ["The Nameless", "Erollisi Marr"],
  ["The Seventh Hammer", "Tunare"],
  ["The Sleeper", "The Combine"],
  ["The Tribunal", "Bristlebane"],
  ["Tholuxe Paells", "Bertoxxulous"],
  ["Torvonnilous", "Fennin Ro"],
  ["Trakanon", "Vox"],
  ["Vallon Zek", "Zek"],
  ["Vazaelle", "Maelin Starpyre"],
  ["Veeshan", "Luclin"],
  ["Venril Sathir", "Antonius Bayle"],
  ["Vulak'Aerr", "Fippy Darkpaw"],
  ["Xev", "Druzzil Ro"],
  ["Zebuxoruk", "Xegony"]
];

// Fully realized server merge pairs showing all [originalServer, finalDestinationServer] combinations
export const fullyRealizedServerMergePairs: [string, string][] = [
  ["Ayonae Ro", "Bristlebane"],
  ["Ayonae Ro", "The Tribunal"],
  ["Brekt", "Firiona Vie"],
  ["Brell Serilis", "Cazic-Thule"],
  ["Druzzil Ro", "Xegony"],
  ["E'ci", "Tunare"],
  ["Fennin Ro", "Cazic-Thule"],
  ["Fippy Darkpaw", "Vox"],
  ["Innoruuk", "Erollisi Marr"],
  ["Innoruuk", "The Nameless"],
  ["Kael Drakkel", "Antonius Bayle"],
  ["Kane Bayle", "Antonius Bayle"],
  ["Karana", "The Rathe"],
  ["Lanys T'Vyl", "The Seventh Hammer"],
  ["Lanys T'Vyl", "Tunare"],
  ["Lockjaw", "Ragefire"],
  ["Maelin Starpyre", "Drinal"],
  ["Mayong", "Tunare"],
  ["Miragul", "Vox"],
  ["Mithaniel Marr", "Bertoxxulous"],
  ["Mithaniel Marr", "Saryrn"],
  ["Morden Rasp", "Povar"],
  ["Morell Thule", "Erollisi Marr"],
  ["Phingel", "Vox"],
  ["Prexus", "The Rathe"],
  ["Quellious", "Povar"],
  ["Rallos Zek", "Zek"],
  ["Rodcet Nife", "Povar"],
  ["Rodcet Nife", "Quellious"],
  ["Saryrn", "Bertoxxulous"],
  ["Sebilis", "Antonius Bayle"],
  ["Solusek Ro", "Bristlebane"],
  ["Stormhammer", "Player Choice"],
  ["Stromm", "Luclin"],
  ["Sullon Zek", "Zek"],
  ["Tallon Zek", "Zek"],
  ["Tarew Marr", "Drinal"],
  ["Terris Thule", "Prexus"],
  ["Terris Thule", "The Rathe"],
  ["The Combine", "Druzzil Ro"],
  ["The Combine", "Xegony"],
  ["The Nameless", "Erollisi Marr"],
  ["The Seventh Hammer", "Tunare"],
  ["The Sleeper", "Druzzil Ro"],
  ["The Sleeper", "The Combine"],
  ["The Sleeper", "Xegony"],
  ["The Tribunal", "Bristlebane"],
  ["Tholuxe Paells", "Bertoxxulous"],
  ["Torvonnilous", "Cazic-Thule"],
  ["Torvonnilous", "Fennin Ro"],
  ["Trakanon", "Vox"],
  ["Vallon Zek", "Zek"],
  ["Vazaelle", "Drinal"],
  ["Vazaelle", "Maelin Starpyre"],
  ["Veeshan", "Luclin"],
  ["Venril Sathir", "Antonius Bayle"],
  ["Vulak'Aerr", "Fippy Darkpaw"],
  ["Vulak'Aerr", "Vox"],
  ["Xev", "Druzzil Ro"],
  ["Xev", "Xegony"],
  ["Zebuxoruk", "Xegony"]
];

// Server merge chains showing the sequence of merges
export const serverMergeChains: string[][] = [
  ["Ayonae Ro", "The Tribunal", "Bristlebane"],
  ["Brekt", "Firiona Vie"],
  ["Brell Serilis", "Cazic-Thule"],
  ["Druzzil Ro", "Xegony"],
  ["E'ci", "Tunare"],
  ["Fennin Ro", "Cazic-Thule"],
  ["Fippy Darkpaw", "Vox"],
  ["Innoruuk", "The Nameless", "Erollisi Marr"],
  ["Kael Drakkel", "Antonius Bayle"],
  ["Kane Bayle", "Antonius Bayle"],
  ["Karana", "The Rathe"],
  ["Lanys T'Vyl", "The Seventh Hammer", "Tunare"],
  ["Lockjaw", "Ragefire"],
  ["Maelin Starpyre", "Drinal"],
  ["Mayong", "Tunare"],
  ["Miragul", "Vox"],
  ["Mithaniel Marr", "Saryrn", "Bertoxxulous"],
  ["Morden Rasp", "Povar"],
  ["Morell Thule", "Erollisi Marr"],
  ["Phingel", "Vox"],
  ["Prexus", "The Rathe"],
  ["Quellious", "Povar"],
  ["Rallos Zek", "Zek"],
  ["Rodcet Nife", "Quellious", "Povar"],
  ["Saryrn", "Bertoxxulous"],
  ["Sebilis", "Antonius Bayle"],
  ["Solusek Ro", "Bristlebane"],
  ["Stormhammer", "Player Choice"],
  ["Stromm", "Luclin"],
  ["Sullon Zek", "Zek"],
  ["Tallon Zek", "Zek"],
  ["Tarew Marr", "Drinal"],
  ["Terris Thule", "Prexus", "The Rathe"],
  ["The Combine", "Druzzil Ro", "Xegony"],
  ["The Nameless", "Erollisi Marr"],
  ["The Seventh Hammer", "Tunare"],
  ["The Sleeper", "The Combine", "Druzzil Ro", "Xegony"],
  ["The Tribunal", "Bristlebane"],
  ["Tholuxe Paells", "Bertoxxulous"],
  ["Torvonnilous", "Fennin Ro", "Cazic-Thule"],
  ["Trakanon", "Vox"],
  ["Vallon Zek", "Zek"],
  ["Vazaelle", "Maelin Starpyre", "Drinal"],
  ["Veeshan", "Luclin"],
  ["Venril Sathir", "Antonius Bayle"],
  ["Vulak'Aerr", "Fippy Darkpaw", "Vox"],
  ["Xev", "Druzzil Ro", "Xegony"],
  ["Zebuxoruk", "Xegony"]
]; 